module.exports = __webpack_public_path__ + "static/img/m_ranking_banner.987484a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/m_ranking_banner.png
// module id = zIP0
// module chunks = 1